export const allowedGlobalView = ['allow Global View'];
